<script setup lang="ts">
import { onMounted, onUnmounted, useTemplateRef } from 'vue';

import LegChooseStepNewAirRoadSection from '@/components/sections/LegChooseStepNewAirRoadSection.vue';
import { useNewAirRoadViewStore } from '@/stores/useNewAirRoadViewStore';
import * as airRoadConstants from '@/constants/airRoad';

const newAirRoadViewStore = useNewAirRoadViewStore();

const legChooseFormRef = useTemplateRef<HTMLFormElement>('legChooseForm');

onMounted(function () {
  newAirRoadViewStore.setLegChooseFormElement(legChooseFormRef.value);
});

onUnmounted(function () {
  newAirRoadViewStore.setLegChooseFormElement(null);
});
</script>

<template>
  <v-form
    ref="legChooseForm"
    v-model="
      newAirRoadViewStore.bookingStepValidationState[
        airRoadConstants.bookingStepValues.LEG_CHOOSE
      ]
    "
    :class="$style.legChooseNewAirRoadStepForm"
    data-testid="legChooseNewAirRoadStepForm"
    validate-on="lazy"
  >
    <input type="submit" class="hidden" disabled />
    <LegChooseStepNewAirRoadSection
      v-model="newAirRoadViewStore.bookingState"
      :air-road-booking-job="newAirRoadViewStore.data.airRoadBookingJob"
      :addresses="newAirRoadViewStore.data.addresses"
    />
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.legChooseNewAirRoadStepForm {
}
</style>
